module.exports = __webpack_public_path__ + "img/arrow-right-circle.e023df2b.svg";